// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT License.
export var StorageSharedKeyCredential = undefined;
//# sourceMappingURL=StorageSharedKeyCredential.browser.js.map